import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { View } from 'react-native';
import ReactMarkdown from 'react-native-markdown-display';

import CenteredPanel from '../../atoms/centered-panel/centered-panel';
import IconMessage from '../../atoms/icon-message/icon-message';
import { OEText } from '../../atoms/oe-text/oe-text';
import { flex, mt } from '../../style-utils';

export interface LoginMessagePanelProps {
  backAction: () => void;
  type?: 'success' | 'warning';
  title: string;
  message: string;
  textLink: string;
  actionLink: () => void;
}

// Typing hack until ReactMarkdown updates to React 18, it's declared in every component to avoid reutilization
const _ReactMarkdown: React.FC<any> = ({ children, ...props }) => (
  <ReactMarkdown {...props}>{children}</ReactMarkdown>
);

export const LoginMessagePanel = ({
  backAction,
  title,
  type = 'success',
  message = '',
  actionLink,
  textLink,
}: LoginMessagePanelProps) => {
  return (
    <CenteredPanel header={title} backAction={backAction}>
      <View style={[mt(48), flex('align-items-center')]}>
        <IconMessage type={type} />
        <OETextMessage fontSize={16} fontFamily={secondaryFontFamily}>
          <_ReactMarkdown>{message}</_ReactMarkdown>
        </OETextMessage>
        <OETextLink
          fontSize={16}
          fontFamily={secondaryFontFamily}
          fontType="italic"
          onPress={actionLink}
        >
          {textLink}
        </OETextLink>
      </View>
    </CenteredPanel>
  );
};

const OETextMessage = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.dark1,
}))`
  flex: 1;
  align-self: flex-start;
  margin-top: 16px;
  text-align: left;
`;

const OETextLink = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.primary,
}))`
  flex: 1;
  margin-top: 64px;
  text-decoration: underline;
  text-align: left;
  font-style: italic;
`;
